export default {
      id: "youtube-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#youtube",
      toString: function () {
        return this.url;
      }
    }